// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-agreement-container {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  color: #333;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.terms-header {
  text-align: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}
.terms-header h1 {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
}

.last-updated {
  color: #777;
  font-size: 14px;
  margin-top: 0;
}

.terms-intro {
  margin-bottom: 30px;
  line-height: 1.6;
  font-size: 15px;
}
.terms-intro p {
  margin-bottom: 15px;
}

.terms-accordion {
  margin-bottom: 30px;
}

.accordion-item {
  margin-bottom: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
}

.accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background-color: #f8f9fa;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.accordion-header:hover {
  background-color: rgb(242.05, 243.9, 245.75);
}
.accordion-header.active {
  background-color: #e6f2ff;
}
.accordion-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
}

.accordion-icon {
  font-size: 20px;
  font-weight: bold;
  color: #666;
}

.accordion-content {
  background-color: #ffffff;
  overflow: hidden;
  transition: max-height 0.3s ease;
  border-top: 1px solid #e0e0e0;
}

.content-inner {
  padding: 15px;
  font-size: 14.5px;
  line-height: 1.6;
}
.content-inner p {
  margin-bottom: 10px;
}

.terms-footer {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.accept-button,
.decline-button {
  padding: 10px 24px;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.accept-button {
  background-color: #c158c1;
  color: white;
  border: none;
}
.accept-button:hover {
  background-color: #8e2d8e;
}

.decline-button {
  background-color: #ffffff;
  color: #333;
  border: 1px solid #ccc;
}
.decline-button:hover {
  background-color: #f1f1f1;
}

@media (max-width: 768px) {
  .terms-agreement-container {
    padding: 15px;
    margin: 0 10px;
  }
  .terms-header h1 {
    font-size: 20px;
  }
  .accordion-header {
    padding: 12px;
  }
  .accordion-header h3 {
    font-size: 15px;
  }
  .content-inner {
    padding: 12px;
    font-size: 14px;
  }
  .terms-footer {
    flex-direction: column;
    gap: 10px;
  }
  .terms-footer .accept-button,
  .terms-footer .decline-button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/termsandAgreement/index.scss"],"names":[],"mappings":"AA2BA;EACE,wIApBY;EAqBZ,gBAAA;EACA,cAAA;EACA,aAAA;EACA,WA7BW;EA8BX,sBAAA;EACA,kBAAA;EAjBA,yCAkBA;AA1BF;;AA6BA;EACE,kBAAA;EACA,oBAAA;EACA,6BAAA;EACA,mBAAA;AA1BF;AA4BE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AA1BJ;;AA8BA;EACE,WAAA;EACA,eAAA;EACA,aAAA;AA3BF;;AA8BA;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;AA3BF;AA6BE;EACE,mBAAA;AA3BJ;;AA+BA;EACE,mBAAA;AA5BF;;AA+BA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,yBA/EW;EAgFX,eAAA;EAvEA,sCAAA;AA4CF;AA8BE;EACE,4CAAA;AA5BJ;AA+BE;EACE,yBAtFQ;AAyDZ;AAgCE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AA9BJ;;AAkCA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;AA/BF;;AAkCA;EACE,yBAAA;EACA,gBAAA;EAjGA,gCAAA;EAmGA,6BAAA;AA/BF;;AAkCA;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AA/BF;AAiCE;EACE,mBAAA;AA/BJ;;AAmCA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,0BAAA;AAhCF;;AAmCA;;EAEE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EA9HA,yBAAA;AA+FF;;AAmCA;EACE,yBA/Ic;EAgJd,YAAA;EACA,YAAA;AAhCF;AAkCE;EACE,yBAnJY;AAmHhB;;AAoCA;EACE,yBAAA;EACA,WAxJW;EAyJX,sBAAA;AAjCF;AAmCE;EACE,yBAAA;AAjCJ;;AAsCA;EACE;IACE,aAAA;IACA,cAAA;EAnCF;EAuCE;IACE,eAAA;EArCJ;EAyCA;IACE,aAAA;EAvCF;EAyCE;IACE,eAAA;EAvCJ;EA2CA;IACE,aAAA;IACA,eAAA;EAzCF;EA4CA;IACE,sBAAA;IACA,SAAA;EA1CF;EA4CE;;IAEE,WAAA;EA1CJ;AACF","sourcesContent":["// Variables\n$primary-color: #c158c1;\n$primary-hover: #8e2d8e;\n$text-color: #333;\n$light-gray: #f8f9fa;\n$border-color: #e0e0e0;\n$active-bg: #e6f2ff;\n$shadow-color: rgba(0, 0, 0, 0.1);\n$font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen,\n  Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif;\n\n// Mixins\n@mixin transition($property: all, $duration: 0.2s, $timing: ease) {\n  transition: $property $duration $timing;\n}\n\n@mixin box-shadow($shadow...) {\n  box-shadow: $shadow;\n}\n\n@mixin flex-center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n// Terms and Agreement Styles\n.terms-agreement-container {\n  font-family: $font-family;\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 20px;\n  color: $text-color;\n  background-color: #fff;\n  border-radius: 8px;\n  @include box-shadow(0 2px 10px $shadow-color);\n}\n\n.terms-header {\n  text-align: center;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #eee;\n  margin-bottom: 20px;\n\n  h1 {\n    font-size: 24px;\n    font-weight: 600;\n    margin-bottom: 8px;\n  }\n}\n\n.last-updated {\n  color: #777;\n  font-size: 14px;\n  margin-top: 0;\n}\n\n.terms-intro {\n  margin-bottom: 30px;\n  line-height: 1.6;\n  font-size: 15px;\n\n  p {\n    margin-bottom: 15px;\n  }\n}\n\n.terms-accordion {\n  margin-bottom: 30px;\n}\n\n.accordion-item {\n  margin-bottom: 10px;\n  border: 1px solid $border-color;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.accordion-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px;\n  background-color: $light-gray;\n  cursor: pointer;\n  @include transition(background-color);\n\n  &:hover {\n    background-color: darken($light-gray, 2%);\n  }\n\n  &.active {\n    background-color: $active-bg;\n  }\n\n  h3 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 500;\n  }\n}\n\n.accordion-icon {\n  font-size: 20px;\n  font-weight: bold;\n  color: #666;\n}\n\n.accordion-content {\n  background-color: #ffffff;\n  overflow: hidden;\n  @include transition(max-height, 0.3s);\n  border-top: 1px solid $border-color;\n}\n\n.content-inner {\n  padding: 15px;\n  font-size: 14.5px;\n  line-height: 1.6;\n\n  p {\n    margin-bottom: 10px;\n  }\n}\n\n.terms-footer {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  padding-top: 20px;\n  border-top: 1px solid #eee;\n}\n\n.accept-button,\n.decline-button {\n  padding: 10px 24px;\n  border-radius: 4px;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  @include transition();\n}\n\n.accept-button {\n  background-color: $primary-color;\n  color: white;\n  border: none;\n\n  &:hover {\n    background-color: $primary-hover;\n  }\n}\n\n.decline-button {\n  background-color: #ffffff;\n  color: $text-color;\n  border: 1px solid #ccc;\n\n  &:hover {\n    background-color: #f1f1f1;\n  }\n}\n\n// Media Queries\n@media (max-width: 768px) {\n  .terms-agreement-container {\n    padding: 15px;\n    margin: 0 10px;\n  }\n\n  .terms-header {\n    h1 {\n      font-size: 20px;\n    }\n  }\n\n  .accordion-header {\n    padding: 12px;\n\n    h3 {\n      font-size: 15px;\n    }\n  }\n\n  .content-inner {\n    padding: 12px;\n    font-size: 14px;\n  }\n\n  .terms-footer {\n    flex-direction: column;\n    gap: 10px;\n\n    .accept-button,\n    .decline-button {\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
